<template>
  <div v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
    <div class="sh-row-main">
      <div class="row-list-item" v-for="(item, index) in dataList" :key="index">
        <div class="list-img" @click="entoDetailPage({ optIdx: index, productID: item.ProductID, freeCardNum: item.FreeCardNum })">
          <img v-lazy="item.ShowPicUrl" alt="" :key="item.ProductID" />
        </div>
        <div class="list-cnt">
          <div class="list-cnt-title" @click="entoDetailPage({ optIdx: index, productID: item.ProductID, freeCardNum: item.FreeCardNum })">
            <div class="title">
              <!-- <span class="platform-tag tm" v-if="item.ShopType && item.ShopType.toLocaleUpperCase() === 'B'">天猫</span>
                <span class="platform-tag pdd" v-if="item.ShopType && item.ShopType.toLocaleUpperCase() === 'P'">拼多多</span>
                <span class="platform-tag jd" v-if="item.ShopType && item.ShopType.toLocaleUpperCase() === 'J'">京东</span> -->
              <plat-formLogo :shopType="item.ShopType.toLocaleUpperCase()"></plat-formLogo>
              <template>{{ item.TitleShort || '----' }}</template>
            </div>

            <!-- <div class="l-prod-price">
              <div class="price">
                <div class="yuan">￥</div>
                <div class="money">{{ item.FreeCardNum !== null ? 0 : item.SaleDiscountPrice }}</div>
              </div>
              <div class="through"><span>￥</span>{{ item.ProductPrice || '--' }}</div>
            </div> -->
          </div>
          <div class="list-cnt-btm">
            <div class="leftPart">
              <div class="l-prod-price">
                <div class="price">
                  <div class="yuan">￥</div>
                  <div class="money">{{ item.FreeCardNum !== null ? 0 : item.SaleDiscountPrice }}</div>
                </div>
                <div class="through"><span>￥</span>{{ item.ProductPrice || '--' }}</div>
              </div>
              <div class="list-btm-price">
                <div class="l-freecard-tag" v-if="item.FreeCardNum !== null">
                  <span>免单卡</span>
                  <span>{{ isNewcomer ? 1 : item.FreeCardNum }}</span>
                </div>
                <div class="l-rebate-tag">
                  <span class="t">返利</span>
                  <span class="rmb" v-if="item.FreeCardNum !== null">￥{{ item.ProductPrice }}</span>
                  <span class="rmb" v-else-if="item.BuyRebatePrice">￥{{ item.BuyRebatePrice }}</span>
                </div>
              </div>
            </div>
            <div class="opPart">
              <div v-if="item.IsFavorite" class="list-btm-btn" @click="cancelRemind(index, item.ProductID)">取消收藏</div>
              <div v-else class="list-btm-btn" @click="remindMe(index, item.ProductID)">收藏</div>
              <div v-if="getIsShowRemindBtn" class="list-btm-btn" @click="setRemindHandler({ optIdx: index, productId: item.ProductID, IsPrePurchase: item.IsPrePurchase })">
                {{ item.IsPrePurchase ? '已预约' : '预约提醒' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setRemind from '@/mixins/setRemind'
import checkLoginHandler from '@/mixins/checkLoginHandler'
import { mapGetters, mapMutations } from 'vuex'
export default {
  mixins: [setRemind, checkLoginHandler],
  props: {
    dataList: {
      type: Array,
      require: true,
      default: function() {
        return []
      }
    },
    // 是否是新人
    isNewcomer: {
      type: Boolean,
      default: false
    },
    scrollDisabled: {
      type: Boolean,
      default: false
    },
    timeList: {
      type: Array,
      require: true,
      default() {
        return []
      }
    },
    timeIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['getIfShowAppDownloadGuide', 'getIsShowRemindBtn'])
  },
  methods: {
    ...mapMutations(['SET_GUIDE_TO_APP_POPUP_INFO']),
    setRemindHandler({ optIdx = undefined, productId = '', IsPrePurchase = false }) {
      if (!this.loginState) {
        this.checkLoginBeforeOperation()
        return
      }
      // 是否展现预约提醒引导下载APP配置 start
      if (this.getIfShowAppDownloadGuide && !this.getIsApp) {
        let title = IsPrePurchase ? '该功能为APP限定功能' : '前往下载APP'
        let desc = IsPrePurchase ? '请前往APP继续操作取消预约' : '由于公众号通知权限预约提醒功能在APP才能使用哦~'
        let isLinkToApp = IsPrePurchase ? false : true
        this.SET_GUIDE_TO_APP_POPUP_INFO({
          isShow: true,
          title,
          desc,
          isLinkToApp
        })
        return
      }
      // 是否展现预约提醒引导下载APP配置 start
      this.optIdx = optIdx
      let remindTimeOriginal = []
      let cancelTimeOriginal = []
      const nodeList = [this.timeList[this.timeIndex]]
      if (IsPrePurchase) {
        cancelTimeOriginal = nodeList
      } else {
        remindTimeOriginal = nodeList
      }

      this.setRemind({
        productId,
        remindTimeOriginal,
        cancelTimeOriginal
      })
    },
    setRemindResSucessHandler() {
      const currentTimeNode = this.timeList[this.timeIndex]
      const { IsPrePurchase } = this.dataList[this.optIdx]
      const res1 = this.remindTimeOriginal.findIndex((remindTimeOriginalVal) => {
        return remindTimeOriginalVal.Node === currentTimeNode.Node && !IsPrePurchase
      })
      const res2 = this.cancelTimeOriginal.findIndex((cancelTimeOriginalVal) => {
        return cancelTimeOriginalVal.Node === currentTimeNode.Node && IsPrePurchase
      })
      if (res1 >= 0 || res2 >= 0) {
        this.$emit('setRemindResSucessHandler', this.optIdx)
      }
    },
    loadMore() {
      this.$emit('loadMore')
    },
    remindMe(index, productId) {
      this.$emit('remindMe', index, productId)
    },
    cancelRemind(index, productId) {
      this.$emit('cancelRemind', index, productId)
    },
    entoDetailPage({ optIdx = undefined, productID = '', freeCardNum = '' }) {
      this.optIdx = optIdx
      let isFreeCard = false
      if (freeCardNum !== null) {
        isFreeCard = true
      }
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: isFreeCard
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.sh-row-main {
  /* padding-top: 3%; */
  background: linear-gradient(to bottom, #fff 0, #f1f1f1 300px, #f1f1f1);
}
.row-list-item {
  position: relative;
  display: flex;
  align-items: center;
  height: vw(125);
  width: 100%;
  box-sizing: border-box;
  padding: vw(8) vw(10);
  background: #fff;
  margin-top: vw(10);
}
.row-list-item:first-child {
  margin-top: 0;
}
.row-list-item .list-img {
  position: relative;
  width: vw(109);
  height: 100%;
  flex-shrink: 0;
}
.list-img img {
  display: block;
  height: 100%;
  width: 100%;
  border-radius: vw(3);
}
.row-list-item .list-cnt {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  margin-left: vw(10);
  flex-grow: 1;
  height: 100%;
  box-sizing: border-box;
}
.list-cnt-title {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list-cnt-title .title {
  max-height: vw(40);
  line-height: vw(20);
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.list-cnt-btm {
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
  .leftPart {
    flex-shrink: 0;
  }
}
.list-btm-price {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #f23030;
  font-size: vw(20);
  line-height: vw(20);
  flex-shrink: 0;
  height: vw(22);
  padding: vw(2) 0;
}
.opPart {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.list-btm-btn {
  height: vw(22);
  min-width: vw(56);
  line-height: vw(22);
  text-align: center;
  color: #000;
  border: vw(1) solid #000;
  padding: vw(2) 0;
  border-radius: vw(15);
  font-size: vw(12);
  margin-left: vw(4);
  margin-top: vw(4);
  &:first-child {
    margin-left: 0;
  }
}
</style>
